import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  EditSensitiveDataPolicyLoader,
  EditSensitiveDataTypeForm,
  UpdateSensitiveDataPolicyMutation
} from '../../../components/sensitive-data'
import { getSensitiveDataTypeIDFromLocation } from '../../../components/route/current-route'
import { routeToSensitiveDataGrid } from '../../../components/sensitive-data/edit-sensitive-data-type-form'

function Bridge({ organizationID }) {
  if (typeof organizationID !== 'string') {
    throw new Error('organizationID is required')
  }
  const policyID = getSensitiveDataTypeIDFromLocation()
  if (!policyID) {
    throw new Error('policyID is required')
  }
  return (
    <EditSensitiveDataPolicyLoader
      organizationID={organizationID}
      policyID={policyID}
    >
      {({ loading, data }) => {
        return (
          <UpdateSensitiveDataPolicyMutation>
            {(updateFn) => {
              return (
                <EditSensitiveDataTypeForm
                  organizationID={organizationID}
                  policyID={policyID}
                  loading={loading}
                  policy={!!data ? data.sensitiveDataPolicy : undefined}
                  update={async ({ organizationID, policyID, rules }) => {
                    await updateFn({
                      organizationID,
                      policyID,
                      rules
                    })
                    routeToSensitiveDataGrid(organizationID)
                  }}
                />
              )
            }}
          </UpdateSensitiveDataPolicyMutation>
        )
      }}
    </EditSensitiveDataPolicyLoader>
  )
}

export const reactSensitiveDataTypeForm = createNgReactBridgeDirective(
  'reactSensitiveDataTypeForm',
  [],
  Bridge,
  ['organizationID']
)
